import React from 'react'
import { Form } from 'antd'
import CheckException from './CheckException'
import ACHException from './ACHException'

interface Props {
  exceptionType: string
  control: any
  exceptionStatus: string
  isACH: boolean
  hasIssuedCheckFile: boolean
}

function ExceptionInfo(props: Props) {
  const { control, exceptionStatus, isACH, hasIssuedCheckFile } = props
  return (
    <Form className='detailCheckInfo' layout='vertical'>
      {isACH ? (
        <ACHException control={control} exceptionStatus={exceptionStatus} />
      ) : (
        <CheckException control={control} exceptionStatus={exceptionStatus} hasIssuedCheckFile={hasIssuedCheckFile} />
      )}
    </Form>
  )
}

export default ExceptionInfo
